import { BasketCard, BasketProductCardSkeleton } from 'components'
import { useBasketInformation } from '../../model/useBasketInfomation'
import { useGetProductDetailQuery } from '../../../ProductDetails/api/suppliers/apiProductSlice'
import { useAppSelector } from 'libraries/redux'
import { ProductSelectors } from 'store/product/selectors'
import { useContext } from 'react'
import { SupplierContext } from 'context/SupplierContext'

function BasketProductCard() {
  const { basketList, refetchCart } = useBasketInformation()

  return (
    <>
      {basketList?.data?.flatMap((data: any) => {
        return <ProductBasketCards key={data.cart_id} data={data} refetchCart={refetchCart} />
      })}
    </>
  )
}

// Component to fetch warehouse data once per product
function ProductBasketCards({ data, refetchCart }: any) {
  const { is_supplier } = useContext(SupplierContext)

  // Fetch product details to get warehouse stock data
  const { data: supplierProductDetails } = useGetProductDetailQuery(data?.product_id || data?.id, {
    skip: !is_supplier,
  })
  const { data: forDetails } = useAppSelector(ProductSelectors.productDetails)

  // Get warehouse data from product details
  const warehouses = is_supplier
    ? supplierProductDetails?.data?.options?.find((w: any) => w.warehouses)?.warehouses
    : forDetails?.options?.find((w: any) => w.warehouses)?.warehouses || []

  const options = data?.options || []

  // Group options by size value
  const groupedOptions = options.reduce(
    (acc: any, opt: any) => {
      const key = opt.value
      if (!acc[key]) {
        acc[key] = {
          value: opt.value,
          totalQuantity: 0,
          mainOption: null as any,
          extraOption: null as any,
        }
      }
      acc[key].totalQuantity += opt.quantity
      if (opt.warehouse?.id === 0) acc[key].mainOption = opt
      else if (opt.warehouse?.id === 2) acc[key].extraOption = opt

      return acc
    },
    {} as Record<
      string,
      {
        value: string
        totalQuantity: number
        mainOption: any
        extraOption: any
      }
    >
  )

  // Create a separate BasketCard for each size variant
  return (
    <>
      {Object.values(groupedOptions).map((optionGroup: any) => (
        <BasketCard
          key={`${data.cart_id}-${optionGroup.value}`}
          data={data}
          optionGroup={optionGroup}
          refetch={refetchCart}
          warehouses={warehouses}
        />
      ))}
    </>
  )
}
export default BasketProductCard

export const renderBasketProductCardSkeletons = Array.from({ length: 2 }).map((_, index) => (
  <BasketProductCardSkeleton key={index} />
))
